<template>
  <section>
    <div>Please, specify the path for the test component.</div>
    <div>
      Example:
      `/vue-tests?component=module/&lt;module&gt;/tests/&lt;TargetComponent&gt;`
    </div>
  </section>
</template>

<script>
export default {
  name: 'DefaultTestComponent'
}
</script>

<style scoped>
section {
  padding: 30px;
}
</style>



// WEBPACK FOOTER //
// src/modules/tests/components/DefaultTestComponent.vue